module.exports = __webpack_public_path__ + "img/sonargroup-services.7a582713.webp";